import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IUserNotifications, IReduxRequestNode } from "@litres-libs/types";
import { Request } from "../../request/Request";
import { addHydrateReducer } from "../../utils/hydrateReducer";

export interface INotificationsState extends IUserNotifications {
  /** Статус запроса */
  isLoading: boolean;
  error?: {
    status: number;
    statusText: string;
  };
}

const initialState: INotificationsState = {
  isLoading: false,
  unreadedCount: 0,
  allCount: 0,
  list: [],
};

// TODO: Не работает, проверить передаваемые параметры в первоисточнике
export const getUserNotifications = createAsyncThunk(
  "user/notifications/getUserNotifications",
  async () => {
    const response = new Request.Cat3<null, IUserNotifications>({
      url: "/account/spam/",
      provider: {
        id: "GET_USER_NOTIFICATIONS",
      },
    });

    return await response.fetch();
  }
);

export const notificationsSlice = createSlice({
  name: "user/notifications",
  initialState,
  reducers: {
    setUserNotifications: (
      state: INotificationsState,
      action: PayloadAction<IUserNotifications>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "user.notifications");
    // Загрузка
    builder.addCase(
      getUserNotifications.pending,
      (state: INotificationsState) => {
        state.isLoading = true;
        state.error = undefined;
      }
    );
    // Ответ
    builder.addCase(
      getUserNotifications.fulfilled,
      (
        state: INotificationsState,
        action: PayloadAction<IReduxRequestNode<null, IUserNotifications>>
      ) => {
        state.isLoading = false;

        // TODO: Ошибку точно не надо как-то визуально обработать в интерфейсе?
        if (action.payload.error) {
          console.error(
            "Ошибка запроса getUserNotifications",
            action.payload.error
          );
          return;
        }

        if (
          typeof action.payload.response === "object" &&
          action.payload.response.list
        ) {
          return {
            ...state,
            ...action.payload.response,
          };
        }
      }
    );
  },
});

export const { setUserNotifications } = notificationsSlice.actions;

export default notificationsSlice.reducer;
